module.exports = __webpack_public_path__ + "static/media/portfolio-masonry-6.13d9a1ec.jpg";